import React from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Injury } from '../assets/injury.svg?react'

export function PageNotFound() {
  const { t } = useTranslation()
  return (
    <div className='p-8 w-full text-center'>
      <div className='font-bold text-4xl leading-[2] flex-cc mb-4'>
        <div>{t('Oops! Page Not Found')}</div>
        <Injury className='dark:fill-slate-900' width={64} height={64} />
      </div>
      <div className='text-base w-full'>
        <div className='max-w-[480px] m-auto'>{t("Unable to locate the page you're looking for.")}</div>
      </div>
    </div>
  )
}

export function PageDashboardError() {
  const { t } = useTranslation()
  return (
    <div className='p-8 w-full text-center'>
      <div className='font-bold text-4xl leading-[2]'>{t('Service Unavailable')}</div>
      <div>{t('Oops. Something went wrong')}</div>
    </div>
  )
}
